import Loading from "components/Loading";
import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import PermissionDeniedPage from "components/PermissionDenied";
import { MODULE_HOT_DEAL } from "shared/constants";
import Permission from "components/Permission";

const HotDeal = React.lazy(
  () => import("containers/ServiceManagement/HotDeal")
);

function HotDealRoute() {
  return (
    <Route
      path="hot-deal-management"
      element={
        <Suspense fallback={<Loading loading />}>
          <Permission
            children={<HotDeal />}
            permissionDenied={<PermissionDeniedPage />}
            modules={[MODULE_HOT_DEAL]}
          />
        </Suspense>
      }
    />
  );
}

export default HotDealRoute;
